module.exports = __webpack_public_path__ + "img/address.b5246813.jpg";